import React from 'react';
import { motion } from 'framer-motion';
export function WhatIsSection() {
  return <section className="py-10 md:py-16 px-4 bg-secondary-bg" data-id="element-396">
      <div className="max-w-2xl mx-auto text-center" data-id="element-397">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} data-id="element-398">
          <h2 className="font-heading text-xl sm:text-2xl md:text-3xl font-bold text-text-primary mb-3 md:mb-4" data-id="element-399">
            ¿Qué es Código de Restauración 24/7?
          </h2>
          <p className="font-body-serif text-sm md:text-base text-text-secondary leading-relaxed" data-id="element-400">
            Es la{' '}
            <span className="font-bold text-text-primary" data-id="element-401">
              Colección Completa
            </span>{' '}
            para alinear tu energía, limpiar bloqueos y decretar con dirección.
            Te guía paso a paso a ordenar tu hogar y tu mente para crear un{' '}
            <span className="font-bold text-text-primary" data-id="element-402">
              campo estable de manifestación
            </span>
            —donde lo que querés atraer no se queda en intención: se convierte
            en hábitos, decisiones y resultados.
          </p>
        </motion.div>
      </div>
    </section>;
}